/*
 * Copyright (c) Nexign, JSC, 2021-2023.
 */
/**
 * InquiryInfo init translation
 *
 * @author Julia Ignatieva
 * @author Alexander Golshtein
 * @version 1.25.0
 * @since 1.15.0
 */

import { IPageInquiryInfoTranslation } from '../../types/pages/inquiryInfo';

export const initPageInquiryInfoTranslation: IPageInquiryInfoTranslation = {
    attachedFiles: {
        title: '',
        noFilesInfo: '',
    },
    chatHistory: {
        answerBlock: {
            attachFile: '',
            sendAnswer: '',
        },
        approveBlock: {
            attachFile: '',
            confirm: '',
            reject: '',
        },
        closeMoreActions: '',
        noHistoryInfo: '',
        showMoreActions: '',
        title: '',
        errorMessage: '',
    },
    closeModal: {
        btn: '',
        comment: '',
        message: '',
        title: '',
        errorText: '',
    },
    creationInfo: '',
    description: '',
    email: '',
    emptyDescription: '',
    informationForClient: '',
    inquiryOptions: '',
    inquiryTopic: '',
    labelDefined: '',
    labelFinalLine: '',
    labelFinalNote: '',
    labelUndefined: '',
    lastUpdateDate: '',
    phoneNumber: '',
    reportNote: '',
    serviceType: {},
    serviceTypeTitle: '',
    status: '',
    title: '',
    userType: {},
};
